import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import userInfo from "./userInfo";

const rootReducer = combineReducers({
  counter: userInfo,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
